import { Flex, Text } from '@inflearn/ds-react';
import type { ReactNode } from 'react';

interface Props {
  label: string;
  value: ReactNode;
}

export const GiftInfoRow = ({ label, value }: Props) => {
  return (
    <Flex gap={12} w="100%" css={{ flex: 1 }} align="flex-start">
      <Text size="sm" weight={400} color="gray.6" miw={80}>
        {label}
      </Text>
      {typeof value === 'string' ? (
        <Text size="sm" weight={400} color="gray.7">
          {value}
        </Text>
      ) : (
        value
      )}
    </Flex>
  );
};
